import * as S from './styles';
import RewardHeader from './RewardHeader';
import RewardContent from './RewardContent';
import { RewardAnimation } from './RewardAnimation';
import { useRewardAnimation } from './useRewardAnimation';

export const RewardPage = () => {
  const { isAnimationVisible, rewardInfo, hideAnimation } =
    useRewardAnimation();

  return (
    <S.PageContainer>
      <RewardHeader />
      <S.ContentWrapper>
        <RewardContent />
      </S.ContentWrapper>
      <RewardAnimation
        isVisible={isAnimationVisible}
        rewardInfo={rewardInfo}
        onComplete={hideAnimation}
      />
    </S.PageContainer>
  );
};
